import React from "react";
import styled from "styled-components";
import Head from "./components/Head";
import Footer from "./components/Footer";
import Cards from "./components/Cards";

const Team = () => {
  return (
    <>
      <Head />
      <Cards />
      <Footer />
    </>
  );
};

export default Team;
